import React from 'react';
import './assets/scss/themes.scss';
import RouteIndex from './core/routing/routes/Index';
import CustomToast from './core/components/common/CustomToast';
import HardReloadButton from './core/components/common/HardReloadButton';
import { AuthProvider } from './core/contexts/AuthContext';
import { TimezoneProvider } from './core/contexts/TimezoneContext';

function App() {
  return (
    <AuthProvider>
      <TimezoneProvider>
        <HardReloadButton />
        <CustomToast />
        <RouteIndex />
      </TimezoneProvider>
    </AuthProvider>
  );
}

export default App;

